import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const OrganizationTreeContext = /*#__PURE__*/createContext([]);
export function useOrgTreeContext() {
  return useContext(OrganizationTreeContext);
}
export default function OrganizationTreeProvider({
  children,
  tree
}) {
  return /*#__PURE__*/_jsx(OrganizationTreeContext.Provider, {
    value: tree,
    "data-sentry-element": "unknown",
    "data-sentry-component": "OrganizationTreeProvider",
    "data-sentry-source-file": "OrganizationTreeContext.tsx",
    children: children
  });
}